<section
    [id]="id()"
    class="relative w-[260px] h-[300px]"
    [attr.data-testid]="currentTestId()"
    [attr.data-styletarget]="id()"
>
    <section
        [style.opacity]="'0.75'"
        [attr.data-testid]="currentTestId() + '-graph'"
        [attr.data-styletarget]="id() + '-graph'"
        [attr.data-uitype]="'graph'"
        class="w-[160px] h-full absolute bottom-[16px] left-[16px]"
        #graph
    ></section>
    <img
       
        [attr.data-testid]="currentTestId() + '-image'"
        [attr.data-styletarget]="id() + '-image'"
        [attr.data-uitype]="'image'"
        class="absolute left-0 bottom-0 w-full"
        src="/assets/trendlines/truck-flatbed.png"
        alt="Flatbed National Rates"
    />
</section>
<div [attr.data-json-info]="'ntl-spot-flatbed'" class="hidden">
    {{ data() | json }}
</div>
<meta name="description" [content]="data() | json" />